import { Button } from '@suscri/ui';
import { ArrowLeft, CheckCircle2, Mail } from 'lucide-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { AuthShell, authInputClass, authLabelClass } from '../components/AuthShell';
import { trpc } from '../lib/trpc';

export function ForgotPasswordPage() {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const request = trpc.auth.requestPasswordReset.useMutation({
    onSuccess: () => setSent(true),
  });

  return (
    <AuthShell compact title={t('Recuperar contraseña')} subtitle={t('Te ayudamos a volver a entrar de forma segura.') }>
      {sent ? (
        <div className="space-y-5">
          <span className="flex h-12 w-12 items-center justify-center rounded-xl bg-success/10 text-success">
            <CheckCircle2 className="h-6 w-6" aria-hidden="true" />
          </span>
          <p className="text-sm leading-6 text-muted-foreground">
            {t('Si existe una cuenta con')} <strong className="text-foreground">{email}</strong>
            {t(', te hemos enviado un email con instrucciones para restablecer tu contraseña. Revisa también la carpeta de spam.')}
          </p>
          <Link to="/login" className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:text-primary/80">
            <ArrowLeft className="h-4 w-4" /> {t('Volver a iniciar sesión')}
          </Link>
        </div>
      ) : (
        <form
          onSubmit={event => {
            event.preventDefault();
            request.mutate({ email });
          }}
          className="space-y-5"
        >
          <p className="text-sm leading-6 text-muted-foreground">
            {t('Introduce tu email y te enviaremos un enlace para elegir una contraseña nueva.')}
          </p>
          <div>
            <label htmlFor="recovery-email" className={authLabelClass}>Email</label>
            <div className="relative">
              <Mail className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-muted-foreground" />
              <input id="recovery-email" type="email" required autoComplete="email" placeholder="tu@email.com" value={email} onChange={event => setEmail(event.target.value)} className={`${authInputClass} pl-10`} />
            </div>
          </div>
          <Button type="submit" className="w-full" size="lg" disabled={request.isPending}>
            {request.isPending ? t('Enviando…') : t('Enviar enlace')}
          </Button>
          <Link to="/login" className="inline-flex items-center gap-2 text-sm font-medium text-muted-foreground hover:text-foreground">
            <ArrowLeft className="h-4 w-4" /> {t('Volver')}
          </Link>
        </form>
      )}
    </AuthShell>
  );
}
